import { render, staticRenderFns } from "./ActivityItem.vue?vue&type=template&id=d9f0a548&scoped=true"
import script from "./ActivityItem.vue?vue&type=script&lang=js"
export * from "./ActivityItem.vue?vue&type=script&lang=js"
import style0 from "./ActivityItem.vue?vue&type=style&index=0&id=d9f0a548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f0a548",
  null
  
)

export default component.exports